import React, { useEffect, useState } from 'react';
import TrainingService from '../../Service/TrainingService';
import "./TauxReussite.css";
import { buildStyles, CircularProgressbar } from 'react-circular-progressbar';

const SuccessRate = ({ training }) => {
    const [editMode, setEditMode] = useState(false);
    const [rating, setRating] = useState(training.rating || 0); // Default to 0 if rating is null or undefined
    const token = sessionStorage.getItem('token');

    const handleEditClick = () => {
        setEditMode(true);
    };

    const handleInputChange = (event) => {
        setRating(event.target.value);
    };

    const handleSaveClick = async () => {
        const updatedAccueil = { ...training, rating };
        console.log(updatedAccueil);

        try {
            let response;
            if (training.modif) {
                response = await TrainingService.putModifTraining(updatedAccueil);
            } else {
                response = await TrainingService.postModifTraining(updatedAccueil);
            }
            console.log(response);
            setEditMode(false);
        } catch (error) {
            console.error("Erreur lors de la sauvegarde :", error);
        }
    };

    return (
        <div className="taux-reussite-section">
            <h2 className="section-title">Taux de réussite</h2>
            <div className="content-container">
                <div className="circular-progress">
                    {editMode ? (
                        <input
                            type="number"
                            value={rating}
                            onChange={handleInputChange}
                            className="form-control"
                            min="0"
                            max="100"
                            step="1"
                        />
                    ) : (
                        <CircularProgressbar
                            value={parseInt(rating, 10)}
                            text={`${rating} %`}
                            styles={buildStyles({
                                textColor: "#000",
                                pathColor: "#ff4d4d",
                                trailColor: "#17203a",
                                textSize: "16px"
                            })}
                        />
                    )}
                </div>
            </div>
            <div className="button-container">
                {editMode ? (
                    <button className="btn btn-success" onClick={handleSaveClick}>
                        Enregistrer
                    </button>
                ) : (token === '' && (
                    <button className="btn btn-danger" onClick={handleEditClick}>
                        Modifier
                    </button>
                ))}
            </div>
        </div>
    );
};

export default SuccessRate;